import React from "react";

import { useTranslation } from "utils";

import { RequirementLevel } from "models";

import { Flex, Form, KlimRadioGroup } from "components";

import { isRequired, isRequiredForSaving } from "pages/app/all-field-view/utils/getInputRequirementConfig";

type Option = {
  label: string;
  value: boolean;
};

const options: Option[] = [
  {
    label: "fertilizerForm.yes",
    value: true,
  },
  {
    label: "fertilizerForm.no",
    value: false,
  },
];

type FertilizerManagementYesNoFormProps = {
  initialValue: boolean | null;
  disabled?: boolean;
  requirementLevel?: RequirementLevel;
  mixedValues?: boolean;
};

export const FertilizerManagementYesNoForm = ({ initialValue, disabled, requirementLevel, mixedValues }: FertilizerManagementYesNoFormProps) => {
  const { t } = useTranslation("allFieldView");

  return (
    <Flex vertical className="tillage-yes-no-form reduced-view">
      <Flex>
        <h5>{t("fertilizerForm.fertilizerManagement.title")}</h5>
      </Flex>
      <div className="form-container" data-testid="add-edit-fertilizer-management-yes-no-form">
        <Flex justify="space-between" gap="1rem" className="margin-top-100">
          <p>
            {t("fertilizerForm.fertilizerManagement.question")} {isRequired(requirementLevel) && "*"}
          </p>
          <Form.Item
            name="hasFertilizerManagement"
            initialValue={initialValue}
            rules={[{ required: isRequiredForSaving(requirementLevel), message: t("fertilizerForm.fertilizerManagement.required") }]}
            help={mixedValues ? t("cropForm.mixedValues") : undefined}
          >
            <KlimRadioGroup
              className="residue-button"
              size="large"
              type="tertiary"
              dataTestId="fertilizer-management-toggle"
              options={options.map((option) => ({
                label: (
                  <Flex vertical justify="space-around">
                    <span>{t(option.label)}</span>
                  </Flex>
                ),
                value: option.value,
              }))}
              optionType="button"
              buttonStyle="solid"
              disabled={disabled}
            />
          </Form.Item>
        </Flex>
      </div>
    </Flex>
  );
};
